import { render, staticRenderFns } from "./riskInformation.vue?vue&type=template&id=9875571a&"
import script from "./riskInformation.vue?vue&type=script&lang=js&"
export * from "./riskInformation.vue?vue&type=script&lang=js&"
import style0 from "./riskInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports